<template>
  <div v-swiper:mySwiper="swiperOption">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        :style="
          'background:url(' +
          concatImageUrl(banner.imgUrl) +
          ') no-repeat center top'
        "
        :key="index"
        v-for="(banner, index) in banners"
      >
        <a
          v-if="banner.siteUrl == ''"
          href="javascript:;"
          style="width: 100%; display: block"
          :style="{ height: `${height}px` }"
        ></a>
        <a
          v-else
          :href="banner.siteUrl"
          target="_blank"
          style="width: 100%; display: block"
          :style="{ height: `${height}px` }"
        ></a>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import { home } from "../../request";
export default {
  name: "carrousel",
  mixins: [siteMixin],
  data() {
    return {
      banners: [],
      swiperOption: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  props: {
    height: {
      type: Number,
      default: 590,
    },
    page: {
      type: String,
      default: "home",
    },
  },
  mounted() {
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      let type = 1; //1首页  2精品课程(商品列表)
      if (this.page == "productList") {
        type = 2;
      }
      home.getBannerList(this.siteConfig.agencyId, type).then((result) => {
        if (result.status === 1) {
          this.banners = result.data;
          if (type == 2 && this.banners.length === 0) {
            this.banners.push({
              imgUrl: "/Upload/banner/product-banner.png",
              siteUrl: "",
            });
          }
        }
      });
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
};
</script>

<style lang="less" scoped>
@import "~swiper/css/swiper.css";
.swiper-pagination {
  bottom: 50px;
  /deep/.swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background: rgba(255, 255, 255, 0.5);
  }
  /deep/.swiper-pagination-bullet-active {
    background: #2a7ef7;
  }
}
</style>